import { CodebookModel } from 'app/shared/model/shared.model';

export interface SpecialBuildingPartModel {
  idSpecialBuildingPart?: number;
  building: CodebookModel[];
  ibz?: string;
  buildingPart: CodebookModel[];
  specialBuildingPart: CodebookModel[];
  usefulNetArea?: number;
  spaceType: CodebookModel[];
  floor: CodebookModel[];
  floorType: CodebookModel[];
  roomCount: CodebookModel[];
  livingRoomCount: CodebookModel[];
  kitchenCount: CodebookModel[];
  bathroomCount: CodebookModel[];
  separateToiletCount: CodebookModel[];
  disabilityAdaptation: CodebookModel[];
  elevatorAccess: CodebookModel[];
  waterSupplyConnection: CodebookModel[];
  sewageConnection: CodebookModel[];
  electricityConnection: CodebookModel[];
  gasConnection: CodebookModel[];
  internetConnection: CodebookModel[];
  heatingConnection: CodebookModel[];
  heatingEnergySource: CodebookModel[];
  coolingConnection: CodebookModel[];
  note?: string;
  ordering?: number;
}

export interface SpecialBuildingPartView {
  idSpecialBuildingPart: number;
  idBuilding: number;
  buildingName: string;
  ibz: string;
  buildingPart: string;
  specialBuildingPart: string;
  spaceType: string;
  floor: string;
  floorType: string;
  usefulNetArea: number;
  roomCount: string;
  note: string;
  ordering: number;
}

export const specialBuildingPartInitialData: SpecialBuildingPartModel = {
  building: [],
  ibz: '',
  buildingPart: [],
  specialBuildingPart: [],
  usefulNetArea: null,
  spaceType: [],
  floor: [],
  floorType: [],
  roomCount: [],
  livingRoomCount: [],
  kitchenCount: [],
  bathroomCount: [],
  separateToiletCount: [],
  disabilityAdaptation: [],
  elevatorAccess: [],
  waterSupplyConnection: [],
  sewageConnection: [],
  electricityConnection: [],
  gasConnection: [],
  internetConnection: [],
  heatingConnection: [],
  heatingEnergySource: [],
  coolingConnection: [],
  note: '',
};
